var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"box",staticClass:"culture_video"},[_c('div',{staticClass:"video_background"},[_c('div',{staticClass:"shade"},[_c('div',{ref:"box",staticClass:"box"},[_c('video',{ref:"video",staticClass:"video-js vjs-big-play-centered vjs-show-big-play-button-on-pause",attrs:{"controls":""}},[_c('source',{attrs:{"src":_vm.src}})])])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }